import React, { useState } from "react";
import { FooterContainer } from "./FooterContainer";
import { useSelector } from "react-redux";
import useResponsive from "../../hooks/useResponsive";
import { MenuItem } from "@mui/material";
import CustomMenu from "../../components/common/Menu/CustomMenu";

interface FooterProps {
  onSubmit: () => void;
  handleClear: () => void;
  onCreateNewSave?: () => void;
  onCreateInvoiceSave?: () => void;
  onPreviewSave?: () => void;
  onCancelClick?: () => void;
  clearBtn: boolean;
  addressDetailsError: boolean;
  isLoading: boolean;
}

const Footer: React.FC<FooterProps> = ({
  onSubmit,
  handleClear,
  onCreateNewSave,
  onCreateInvoiceSave,
  onPreviewSave,
  clearBtn,
  addressDetailsError,
  isLoading,
  onCancelClick
}) => {
  const contactType = useSelector((state: any) => state.contactType); // Replace `any` with your actual Redux state type
  const isMobile = useResponsive();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const useDebounce = (callback: () => void, delay: number) => {
    const [timeoutId, setTimeoutId] = useState<any>(null);

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      const newTimeoutId = setTimeout(() => {
        callback();
      }, delay);
      setTimeoutId(newTimeoutId);
    };
  };

  const handleSaveOnly = useDebounce(() => {
    if (!isLoading) {
      onSubmit();
    }
  }, 100);

  const handleSaveAndPreview = useDebounce(() => {
    if (!isLoading) {
      onPreviewSave && onPreviewSave();
    }
  }, 100);

  const handleSaveAndCreateNew = useDebounce(() => {
    if (!isLoading) {
      onCreateNewSave && onCreateNewSave();
    }
  }, 100);

  const handleSaveAndCreateInvoice = useDebounce(() => {
    if (!isLoading) {
      onCreateInvoiceSave && onCreateInvoiceSave();
    }
  }, 100);

  const menuItems = () => (
    <>
      <MenuItem onClick={handleSaveOnly}>Save Only</MenuItem>
      {onPreviewSave &&  <MenuItem onClick={handleSaveAndPreview}>Save & Print/Preview</MenuItem>}
      {onCreateNewSave &&  <MenuItem onClick={handleSaveAndCreateNew}>Save & Create New</MenuItem>}
    {onCreateInvoiceSave && <MenuItem onClick={handleSaveAndCreateInvoice}>
        Save & Create{" "}
        {contactType === "customers"
          ? "Invoice"
          : contactType === "suppliers"
          ? "Purchase"
          : ""}
      </MenuItem>}
    </>
  );

  return (
    <FooterContainer>
      <div className="footer-section">
        <div>
          <button
            onClick={onCancelClick}
            className="btn btn-sm btn-danger mr-2"
          >
            Cancel
          </button>
          {clearBtn && (
            <button onClick={handleClear} className="btn btn-sm btn-warning">
              Clear
            </button>
          )}
        </div>
        {isMobile ? (
          <>
            <button
              onClick={(e) => setAnchorEl(e.currentTarget)}
              className="btn btn-sm btn-success"
              disabled={addressDetailsError}
            >
              Save with
            </button>

            <CustomMenu
              menuItems={menuItems()}
              openMenu={open}
              handleClose={handleClose}
              anchorEl={anchorEl}
            />
          </>
        ) : (
          <>
            <div>
                {onPreviewSave &&  <button
                onClick={handleSaveAndPreview}
                className="btn btn-sm btn-success"
                disabled={addressDetailsError || isLoading}
              >
                Save & Print/Preview
              </button>}
            </div>
            <div>
              <button
                onClick={handleSaveOnly}
                className="btn btn-sm btn-primary mr-2"
                style={{ position: "relative", display: "inline-block" }}
                disabled={addressDetailsError || isLoading}
              >
                Save
              </button>

                {onCreateNewSave &&  <button
                onClick={handleSaveAndCreateNew}
                className="btn btn-sm btn-primary mr-2"
                disabled={addressDetailsError || isLoading}
              >
                Save & Create New
              </button>}
              {onCreateInvoiceSave && contactType === "customers" ? (
                <button
                  onClick={handleSaveAndCreateInvoice}
                  className="btn btn-sm btn-primary"
                  disabled={addressDetailsError || isLoading}
                >
                  Save & Create Invoice
                </button>
              ) : onCreateInvoiceSave && contactType === "suppliers" ? (
                <button
                  onClick={handleSaveAndCreateInvoice}
                  className="btn btn-sm btn-primary"
                  disabled={addressDetailsError || isLoading}
                >
                  Save & Create Purchase
                </button>
              ) : (
                ""
              )}
            </div>
          </>
        )}
      </div>
    </FooterContainer>
  );
};

export default Footer;